import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IDataCaptureSheet } from '../../models/data-capture.models';

@Component({
  selector: 'app-delete-sheet-confirmation',
  template: `<div class="flex justify-between content-center">
      <h3 mat-dialog-title data-test-id="delete-sheet-confirmation-title">
        Sheet deletion
      </h3>
      <button
        mat-icon-button
        mat-dialog-close
        data-test-id="delete-sheet-confirmation-close-icon"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-dialog-content
      class="flex flex-col gap-2"
      data-test-id="delete-sheet-confirmation-content"
    >
      <p>
        You are about to permanently delete the sheet &lt;{{ data.name }}&gt;.
        This action will remove all associated questions, interview sections,
        and generated expert responses.
      </p>

      <p>This will not affect the underlying transcript data.</p>

      <p>Are you sure you want to continue?</p>

      <form [formGroup]="deleteAnswersForm">
        <mat-checkbox
          formControlName="deleteAnswers"
          data-test-id="delete-sheet-confirmation-confirmation-checkbox"
        >
          <span data-test-id="delete-sheet-confirmation-acknowledgement-label">
            <i
              data-test-id="delete-sheet-confirmation-acknowledgement-error"
              [class.error]="
                deleteAnswersControl.invalid && deleteAnswersControl.touched
              "
            >
              I understand and wish to proceed.
            </i>
          </span>
        </mat-checkbox>
      </form>
    </mat-dialog-content>

    <mat-dialog-actions class="flex gap-2">
      <button
        type="button"
        mat-stroked-button
        mat-dialog-close
        color="primary"
        class="flex-1 primaryColor-border"
        data-test-id="delete-sheet-confirmation-cancel-button"
      >
        Close window
      </button>
      <button
        class="flex-1"
        type="submit"
        mat-flat-button
        color="primary"
        (click)="confirmDeletion()"
        data-test-id="delete-sheet-confirmation-confirm-button"
      >
        Confirm
      </button>
    </mat-dialog-actions>`,
  styles: `
    .error {
      color: red;
    }
  `,
  standalone: false,
})
export class DeleteSheetConfirmationComponent {
  deleteAnswersForm = new FormGroup({
    deleteAnswers: new FormControl(false, [Validators.requiredTrue]),
  });

  get deleteAnswersControl() {
    return this.deleteAnswersForm.controls.deleteAnswers;
  }

  constructor(
    private dialogRef: MatDialogRef<DeleteSheetConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDataCaptureSheet
  ) {}

  confirmDeletion() {
    if (this.deleteAnswersForm.invalid) {
      this.deleteAnswersForm.markAllAsTouched();
      return;
    }

    this.dialogRef.close(true);
  }
}
